export const priceTableConfig = {
  // Add translation keys to template when new columns are added here
  columns: [
    { prop: 'name', translationKey: 'name', flexGrow: 2 },
    { prop: 'tariffModel', translationKey: 'tariff_model', flexGrow: 3 },
    { prop: 'country', translationKey: 'country', flexGrow: 1 },
    { prop: 'currency', translationKey: 'currency', flexGrow: 1 },
    { prop: 'privacyStatus', translationKey: 'privacy_status', flexGrow: 2 },
  ],
};
